import { ActionIcon, Text } from "@mantine/core";
import { IconEdit, IconUsers } from "@tabler/icons-react";
import { BasicProductAttributes } from "../types";
import { CustomInfoCard } from "../routes/customers/CustomInfoCard";

interface RmInformationCardProps {
    product: Pick<BasicProductAttributes, "rm" | "submittedBy" | "referredBy">;
    hideIfNoRm?: boolean;
    onEditRm?: () => void;
    onEditReferredBy?: () => void;
}

const safeRmText = (value: unknown): string | undefined => {
    if (value == null) {
        return undefined;
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number" || typeof value === "boolean") {
        return String(value);
    }
    if (value instanceof Error) {
        return value.message || value.name;
    }
    return undefined;
};

const editableRmValue = (
    label: string,
    value: unknown,
    onEdit?: () => void,
    showPlaceholder = false,
) => {
    const displayValue = safeRmText(value);

    if (!displayValue && !onEdit && !showPlaceholder) {
        return null;
    }

    return (
        <Text tt="capitalize" className="showBtnOnHover" fw={500} size="sm" ta="right">
            <>
                {displayValue || "-"}
                {onEdit && (
                    <ActionIcon variant="white" ml={4} aria-label={label} onClick={onEdit}>
                        <IconEdit style={{ width: "70%", height: "70%" }} stroke={1.5} />
                    </ActionIcon>
                )}
            </>
        </Text>
    );
};

export const RmInformationCard = ({
    product,
    hideIfNoRm = false,
    onEditRm,
    onEditReferredBy,
}: RmInformationCardProps) => {
    if (hideIfNoRm && !product.rm) {
        return null;
    }
    const showRmPlaceholders = !hideIfNoRm || !!product.rm;

    return (
        <CustomInfoCard
            title="RM Information"
            color="blue"
            icon={<IconUsers size={16} />}
            list={[
                {
                    label: "RM Name",
                    value: editableRmValue("Change RM", product.rm?.name_en, onEditRm, showRmPlaceholders),
                },
                {
                    label: "Segment",
                    value: safeRmText(product.rm?.segment),
                },
                {
                    label: "RM Email",
                    value: safeRmText(product.rm?.email),
                    noCapitalize: true,
                },
                {
                    label: "Submitted By",
                    value: safeRmText(product.submittedBy?.name_en),
                },
                {
                    label: "Submitter Email",
                    value: safeRmText(product.submittedBy?.email),
                    noCapitalize: true,
                },
                {
                    label: "Referred By",
                    value: editableRmValue("Change Referred by RM", product.referredBy?.name_en, onEditReferredBy, showRmPlaceholders),
                },
                {
                    label: "Referrer Email",
                    value: safeRmText(product.referredBy?.email),
                    noCapitalize: true,
                },
            ]}
        />
    );
};
